// components/CapacityWait.jsx
// Friendly message shown to candidates when interview capacity is reached
// Used in InterviewPage when join returns status: "awaiting_capacity"

import React from 'react';

export default function CapacityWait({ 
  jobTitle, 
  companyName, 
  candidateEmail,
  message 
}) {
  return (
    <div className="capacity-wait-page">
      <div className="capacity-wait-container">
        <div className="capacity-wait-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="38" stroke="url(#gradient)" strokeWidth="4"/>
            <path d="M40 20V44" stroke="url(#gradient)" strokeWidth="4" strokeLinecap="round"/>
            <circle cx="40" cy="54" r="3" fill="#22d3ee"/>
            <defs>
              <linearGradient id="gradient" x1="0" y1="0" x2="80" y2="80">
                <stop stopColor="#22d3ee"/>
                <stop offset="1" stopColor="#0ea5e9"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        <h1>Thanks for your interest!</h1>
        
        <div className="capacity-wait-message">
          <p>
            We're excited about your application for <strong>{jobTitle}</strong>
            {companyName && <> at <strong>{companyName}</strong></>}!
          </p>
          
          <p>
            We're experiencing high demand and are making a quick upgrade 
            to accommodate everyone. We'll email you at{' '}
            <strong>{candidateEmail}</strong> as soon as we're ready for 
            your interview.
          </p>
          
          <div className="wait-info">
            <div className="wait-info-icon">⏱️</div>
            <div>
              <strong>This usually takes less than 24 hours.</strong>
              <br />
              No action needed on your part – we'll send you a fresh link when ready.
            </div>
          </div>
        </div>
        
        <div className="capacity-wait-footer">
          <p>Questions? Contact the hiring team directly.</p>
        </div>
      </div>
      
      <style jsx>{`
        .capacity-wait-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        
        .capacity-wait-container {
          background: white;
          border-radius: 24px;
          padding: 48px;
          max-width: 520px;
          text-align: center;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }
        
        .capacity-wait-icon {
          margin-bottom: 24px;
        }
        
        .capacity-wait-container h1 {
          margin: 0 0 24px 0;
          font-size: 28px;
          color: #0f172a;
          font-weight: 700;
        }
        
        .capacity-wait-message {
          text-align: left;
        }
        
        .capacity-wait-message p {
          font-size: 16px;
          line-height: 1.6;
          color: #334155;
          margin: 0 0 16px 0;
        }
        
        .capacity-wait-message strong {
          color: #0f172a;
        }
        
        .wait-info {
          display: flex;
          gap: 16px;
          background: linear-gradient(135deg, #ecfeff, #f0fdfa);
          border: 1px solid #99f6e4;
          border-radius: 12px;
          padding: 20px;
          margin-top: 24px;
        }
        
        .wait-info-icon {
          font-size: 32px;
          flex-shrink: 0;
        }
        
        .wait-info div {
          font-size: 14px;
          color: #0f766e;
          line-height: 1.5;
        }
        
        .wait-info strong {
          color: #0f766e;
        }
        
        .capacity-wait-footer {
          margin-top: 32px;
          padding-top: 24px;
          border-top: 1px solid #e2e8f0;
        }
        
        .capacity-wait-footer p {
          margin: 0;
          font-size: 14px;
          color: #94a3b8;
        }
        
        @media (max-width: 600px) {
          .capacity-wait-container {
            padding: 32px 24px;
          }
          
          .capacity-wait-container h1 {
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  );
}
